import React from 'react';
import { Route, Switch, Redirect, useLocation } from 'react-router-dom';
import { withPermissionsAndRoles, withSession } from './session';
import Projects from '../components/refereshed-components/projects/projects';
import MemberManagement from './members/members';
import Certificate from './certificate/certificate';
import ApiUsageView from './apiUsageView/usageTab';
import ProjectDetails from './projectDetails/projectDetails';
import ContactManagement from './contactManagement/contactManagement';
import AccessDenied from './layout/accessDenied';
import BannerMessage from './layout/bannerMessage';
import PartnerProjectList from './partnerProjects/projectList';
import ProjectDetail from "./partnerProjects/projectDetail";
import RoleManagement from './roleManagement/roleManagement.js';
import TemplateManagement from './templateManagement/templateManagement.js';
import RevShare from './revShare/revShare';
import IRecBillingManagement from './billing/iRecBillingManagement';
import { APP_ROLES } from "./constants";
import CiaManager from './oneux-layout/ciaManager/ciaManager';
import SiClients from './acceleratorClients/siClients';
import ClientProjectDetails from './clientProjects/clientProjectDetails';
import ChangeHistory from './apiDiscovery/changeHistory/index.jsx';
import { RelatedGuides } from 'shared-one-ux-components';

const BaseRoutes = ({ session, roles }) => {
	const routes = [];
	const { pathname } = useLocation();
	const location = useLocation();

	if (roles.includes(APP_ROLES.PARTNER_USER) || roles.includes(APP_ROLES.DATACLOUD_USER)) {
		routes.push(
			<Route key={'route-key-root-projects'} exact path={'/'}><Redirect to="/projects" /></Route>,

			<Route key={'route-key-certificate-action'} exact path={'/certificate/:action?'} render={() => (
				<Certificate
					email={session.email}
				/>
			)}
			/>,

			<Route key={'route-key-related-guides'} exact path={'/projects/:projectId/related-guides'}
				render={(props) =>
					<RelatedGuides {...props} location={location} host={`${import.meta.env.VITE_ROOT_PATH}`} />
				}
			/>,

			<Route key={'route-key-projects'} exact path={'/projects/'} component={Projects} />,

			<Route key={'route-key-projects-change-history'} exact path={'/projects/:projectID/change-history'} component={ChangeHistory} />,

			<Route key={'route-key-enduser'} exact path={'/projects/:projectId/:credentials?/:enduser?'} component={ProjectDetails} />,
			
			<Route key={'route-key-members'} exact path={'/members'} render={props => <MemberManagement {...props} roles={roles} />} />
		);
	}


	if (roles.includes(APP_ROLES.PARTNER_USER)) {
		routes.push(
			<Route key={'route-key-accelerator-clients'} exact path={'/accelerator-clients'} render={() => <SiClients />} />,
			<Route key={'route-key-projects-change-history'} exact path={'/accelerator-projects/:clientOOID/change-history/:projectID'} component={ChangeHistory} />,
			<Route key={'route-key-accelerator-projects'} exact path={'/accelerator-projects/:ooid?'} component={ClientProjectDetails} />
		)
	}

	if (roles.includes(APP_ROLES.CERTIFICATE_ADMIN)) {
		routes.push(
			<Route key={'route-key-root-certificate-action'} exact path={'/'}><Redirect to="/certificate" /></Route>,
			<Route key={'route-key-certificate-action'} exact path={'/certificate/:action?'} render={() => (
				<Certificate
					email={session.email}
				/>
			)}
			/>
		);
	}

	if (roles.includes(APP_ROLES.DATACLOUD_USER)) {
		routes.push(
			<Route key={'route-key-root-api-usage'} exact path={'/'}><Redirect to="/api-usage" /></Route>,
			<Route key={'route-key-api-usage'} exact path={'/api-usage/'} component={ApiUsageView} />
		);
	}

	if (roles.includes(APP_ROLES.PARTNER_ADMIN)) {
		routes.push(
			<Route key={'route-key-root-partner-orgs'} exact path={'/'}><Redirect to="/contacts/partners" /></Route>,
			<Route key={'route-key-partner-projects'} exact path={'/partner-projects/'} component={PartnerProjectList} />,
			<Route key={'route-key-partner-projects'} exact path={'/partner-projects/:projectId?'} component={ProjectDetail} />,
			<Route key={'route-key-contacts-partners'} exact path={'/contacts/:partners?'} component={ContactManagement} />
		);
	}

	if (roles.includes(APP_ROLES.TEMPLATE_ADMIN)) {
		routes.push(
			<Route key={'route-key-root-template-management'} exact path={'/'}><Redirect to="/template-manager" /></Route>,
			<Route key={'route-key-template-management'} exact path={'/template-manager'} component={TemplateManagement} />
		);
	}

	if (roles.includes(APP_ROLES.SUPER_USER)) {
		routes.push(
			<Route key={'route-key-root-role-management'} exact path={'/'}><Redirect to="/roleManagement" /></Route>,
			<Route key={'route-key-role-management'} exact path={'/roleManagement/:action?'} component={RoleManagement} />
		)
	}
	if (roles.includes(APP_ROLES.RS_PARTNER) || roles.includes(APP_ROLES.ACCOUNTS_RECEIVABLE) || roles.includes(APP_ROLES.BILLING_ADMIN)) {
		routes.push(
			<Route key={'route-key-root-rev-share'} exact path={'/'}><Redirect to="/revShare" /></Route>,
			<Route key={'route-key-rev-share'} exact path={'/revShare'} component={RevShare} />
		)
	}
	if (roles.includes(APP_ROLES.FINANCIAL_USER)) {
		routes.push(
			<Route key={'route-key-irec-billing'} exact path={'/irec-billing'} component={IRecBillingManagement} />
		);
	}

	if (roles.includes(APP_ROLES.CIA_MANAGER)) {
		routes.push(
			<Route key={'route-key-cia-manager'} exact path={'/ciaManager'} component={CiaManager} />
		);
	}
	routes.push(<Route key={'route-key-access-denied'} exact path={'/access-denied'} render={(props) => <AccessDenied {...props} roles={roles} />} />);
	routes.push(<Redirect key={'redirect-key-access-denied'} to={`/access-denied?error=${pathname === '/error'}`} />);
	routes.push(<Route key={'route-key-not-found'} render={(props) => <BannerMessage {...props} title="404" subtitle="page not found" />} />);
	return <div className="framework-masthead__page">
		<Switch>
			{routes}
		</Switch>
	</div>;
}

export default withSession(withPermissionsAndRoles(BaseRoutes));
